<template>
    <div class="home">
        <van-sticky>
            <van-nav-bar title="商品评价" left-arrow @click-left="$router.go(-1)" />
        </van-sticky>
        <!-- 列表 -->
        <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了" class="evaList">
            <div class="evaItem" v-for='(item,index) in list' :key='index'>
                <div class="itemTop">
                    <img :src="item.head_image" alt="" class="topImg">
                    <div>
                        <div class="topCon">
                            <div class="topNme">{{item.nick_name}}</div>
                            <div class="topRank">***</div>
                        </div>
                        <div class="topDesc">
                            <span>{{item.create_time.split(' ')[0]}}</span>
                            <span>|</span>
                            <span>规格:100g</span>
                        </div>
                    </div>
                </div>
                <div class="itemCon">
                    <div>
                        {{item.content}}
                    </div>
                    <div class="imgWrap" v-if='item.image'>
                        <img :src="item.image" alt="">
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</template>
<script>
    import { goodsEvaluate } from "@/api/home";
    export default {
        data() {
            return {
                form: {
                    id: "",
                    page: 1,
                    pagesize: 10,
                },
                loading: false,
                finished: true,
                list: []
            }
        },
        created() {
            this.form.id = this.$route.query.id;
            this.onLoad();
        },
        methods: {
            onLoad() {
                goodsEvaluate(this.form).then(resp => {
                    this.form.page++;
                    let rows = resp.data;
                    this.count = resp.count;
                    this.loading = false;
                    this.finished = false;
                    if (rows == null || rows.length == 0) {
                        this.finished = true;
                        return;
                    }
                    this.list = this.list.concat(rows);
                    if (this.list.length >= this.count) {
                        this.finished = true;
                    }
                });
            }
        }
    }
</script>
<style lang="less" scoped>
    /* 头部 */
    /deep/ .van-tabs {
        height: 42.5px;
        box-sizing: border-box;
        padding: 11.5px 6px;
        width: 100%;

        .van-tabs__wrap {
            height: 21px;
        }

        .van-tab {
            background: #F4F4F4;
            border-radius: 10.5px;
            font-size: 12px;

            padding: 5px;
            margin-right: 4px;
        }

        .van-tab--active {
            background: #FFF1EC;

        }

        .van-tabs__line {
            background-color: transparent;
        }
    }

    .gap {
        width: 100%;
        height: 10px;
        background: #f5f5f5;
    }

    /* 列表 */
    .evaList {
        .evaItem {
            width: 100%;
            box-sizing: border-box;
            padding: 15px;
            border-bottom: 1px solid #EEEEEE;

            .itemTop {
                display: flex;
                color: #999;
                font-size: 12px;

                .topImg {
                    width: 32.5px;
                    height: 32.5px;
                    border-radius: 50%;
                    margin-right: 3px;
                }

                .topCon {
                    display: flex;
                    color: #333333;
                    font-weight: bold;
                    margin: 1px 0 4px 0;
                }
            }

            .itemCon {
                color: #666666;
                font-size: 14px;
                margin-top: 15px;

                img {
                    margin-top: 14.5px;
                    width: 228px;
                    height: 228px;
                    border-radius: 5px;
                }
            }
        }
    }
</style>